// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4b852df5","488":"89cbbeb0","977":"94e8647d"}[chunkId] + ".chunk.js";
};